// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { EnrollmentV2PaymentTypeModels } from './enrollmentV2PaymentTypeModels.js';
import type { Moment } from 'moment';
import type { IAttributeTypeMap, RequestFile } from '@trialcard/shared';

export class EnrollmentPaymentPaymentMethodResponse {
    'data': EnrollmentV2PaymentTypeModels | null;
    'success': boolean;
    'messages': Array<string> | null;

    static readonly discriminator: string | undefined = undefined;

    static readonly additionalProperties = false;

    
    static readonly attributeTypeMap: ReadonlyArray<IAttributeTypeMap<keyof EnrollmentPaymentPaymentMethodResponse>> = [
        {
            "name":     "data",
            "baseName": "data",
            "type":     "EnrollmentV2PaymentTypeModels"
        },
        {
            "name":     "success",
            "baseName": "success",
            "type":     "boolean"
        },
        {
            "name":     "messages",
            "baseName": "messages",
            "type":     "Array<string>"
        },
    ];

    static getAttributeTypeMap() {
        return EnrollmentPaymentPaymentMethodResponse.attributeTypeMap;
    }
}
